(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterBuilder', rmsListFilterBuilder);

    function rmsListFilterBuilder() {
        return {
            restrict: 'E',
            scope: {},
            controller: rmsListFilterBuilderCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/list-filter-builder'
        };
    }

    function rmsListFilterBuilderCtrl(FILTER_STEP_CONSTANT, $scope, lodash) {
        var vm = this,
            filterService = null;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};

            vm.constant = FILTER_STEP_CONSTANT;
            vm.addFilter = addFilter;
            vm.backToPrevious = backToPrevious;
            vm.selectFilter = selectFilter;
            vm.backToStepProperties = backToStepProperties;
            vm.backToAppliedScreen = backToAppliedScreen;
            vm.compareType = compareType;
            vm.reset = reset;
            vm.saveAsView = saveAsView;
            vm.editFilter = editFilter;
            vm.removeFilter = removeFilter;
            vm.hasAppliedFilters = hasAppliedFilters;
            vm.hasFilter = hasFilter;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            filterService = $scope.listFilterService.getFilterService();
            vm.pageData.filters.step = FILTER_STEP_CONSTANT.LIST;
        }

        function backToPrevious() {
            filterService.backToPrevious();
        }

        function addFilter() {
            filterService.goToNext();
        }

        function reset() {
            filterService.clearFilters();
            $scope.listFilterService.refreshGrid(true);
        }

        function selectFilter(filter) {
            filterService.selectFilter(filter);
        }

        function backToStepProperties() {
            if (vm.pageData.filters.editing) {
                filterService.resetCurrent();
            } else {
                filterService.clearCurrentFilter();
                backToPrevious();
            }
        }

        function backToAppliedScreen() {
            vm.pageData.filters.searchFilter = {};
            backToPrevious();
        }

        function compareType(filter, type) {
            return filter.type == type;
        }

        function editFilter(filter) {
            if (hasFilter(filter)) {
                filterService.editFilter(filter);
            }
        }

        function removeFilter($event, filter) {
            $event.stopPropagation();
            filterService.removeFilter(filter);
            $scope.listFilterService.refreshGrid(true);
        }

        function saveAsView() {
            (lodash.get(vm.pageData, 'view_options.selected_view.editable', false) === true)
                ? filterService.updateView()
                : filterService.createView();
        }

        function hasAppliedFilters() {
            return filterService.hasAppliedFilters();
        }

        function hasFilter(applied_filter) {
            return filterService.hasFilter(applied_filter);
        }
    }
})();